import { useEffect, useState } from 'react';
import { SearchApi } from '../services';

export const useClubSearch = ({ enabled = true, query, gender, types }) => {
    const [clubs, setClubs] = useState([]);
    const [nextCursor, setNextCursor] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!enabled) return;

        const timeout = setTimeout(() => {
            fetchClubs();
        }, 250);

        return () => clearTimeout(timeout);
    }, [enabled, query, gender, types]);

    const fetchClubs = async cursor => {
        const trimmedQuery = query.trim();
        if (trimmedQuery.length < 2) {
            setClubs([]);
            setIsLoading(false);
            setError(null);
            return;
        }

        try {
            setIsLoading(true);

            const clubResults = await SearchApi.searchClubs({
                query: trimmedQuery,
                ...(gender && { gender }),
                ...(types && { types })
            });

            setClubs(clubResults);
        } catch (err) {
            setError('[API] Failed to fetch clubs');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchNextPage = async () => {
        if (!nextCursor) return;

        await fetchClubs(nextCursor);
    };

    return {
        clubs,
        isNextPage: !!nextCursor,
        fetchNextPage,
        isLoading,
        error
    };
};
